// Navbar.jsx
import React from 'react';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ModeToggle } from './ModeToggle';
import { getAssetUrl } from '../utils/assetUrl';
import { scrollToSection } from '../utils/scrollToSection';

const navItems = [
  { label: 'The Concept', sectionId: 'concept' },
  { label: 'Intelligence Layer', sectionId: 'features' },
  { label: 'Labor Calculator', sectionId: 'calculator' },
  { label: 'Resources', sectionId: 'resources' },
];

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavClick = (sectionId) => {
    setIsOpen(false);
    scrollToSection(sectionId);
  };

  const handleTakeAudit = () => {
    setIsOpen(false);
    scrollToSection('audit');
  };

  return (
    <nav className="border-b sticky top-0 z-40 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between">
          <div className="flex">
            <div className="flex flex-shrink-0 items-center">
              <Link to="/" className="flex items-center space-x-2">
                <img src={getAssetUrl('/kinetic-logo-48.png')} alt="Kinetic Guard Logo" className="w-8 h-8" />
                <span className="text-xl font-semibold">Kinetic Guard</span>
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.sectionId}
                  onClick={() => handleNavClick(item.sectionId)}
                  className="inline-flex items-center px-1 pt-1 text-sm font-medium border-b-2 border-transparent hover:border-primary transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center sm:space-x-4">
            <ModeToggle />
            <button
              onClick={handleTakeAudit}
              className="text-sm font-medium px-4 py-2 rounded-md bg-accent-orange text-white hover:bg-accent-orange/90 transition-colors"
            >
              Take the Audit
            </button>
          </div>
          <div className="flex items-center sm:hidden">
            <ModeToggle />
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="ml-2 inline-flex items-center justify-center p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted focus:outline-none focus:ring-2 focus:ring-inset focus:ring-ring"
            >
              <span className="sr-only">Open main menu</span>
              {isOpen ? (
                <X className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="sm:hidden">
          <div className="pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <button
                key={item.sectionId}
                onClick={() => handleNavClick(item.sectionId)}
                className="block w-full text-left pl-3 pr-4 py-2 text-base font-medium hover:bg-muted"
              >
                {item.label}
              </button>
            ))}
          </div>
          <div className="pt-4 pb-3 border-t border-border">
            <div className="flex items-center px-4">
              <button
                onClick={handleTakeAudit}
                className="w-full text-center text-sm font-medium px-4 py-2 rounded-md bg-accent-orange text-white hover:bg-accent-orange/90"
              >
                Take the Audit
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
